"use strict";
// @ts-ignore
try {
    self['workbox:precaching:7.3.0'] && _();
}
catch (e) { }
